import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import styles from './AggregateToolbar.module.css';
import { AttributesSelector, DatePicker } from '..';
import { optionalColumnsWithShift } from '../../staticData';
import { Prompt } from 'react-router-dom';
import { DISPLAY_MESSAGES } from '../../constants';
import { callFunctionConditionallyWithWarningCurry } from '../../utils/utils';
import LineDropdownSelector from '../LineDropdownSelector/LineDropdownSelector';

const AggregateToolbar = ({
  restrictNavigationDuringEditing,
  hasActiveEdits,
  activeDate,
  dates,
  handleDateSelect,
  selectedOptionalColNames,
  applyColumnsSelection,
  lastRefreshedDate,
  contextualButtonProps = {},
  showAttributesMenu,
}) => {
  return (
    <div className={styles.RgtTools}>
      <span className={styles.captionSmallBt}>
        {lastRefreshedDate
          ? `Last Refreshed: ${lastRefreshedDate.format(
              'hh:mmA [(IST)] DD MMMM YYYY',
            )}`
          : 'Last Refreshed: --:--'}
      </span>
      <div className={styles.aggregateToolbar}>
        <div className={styles.datesSelectorBar}>
          <DatePicker
            startDate={moment()}
            endDate={dates[dates.length - 1]}
            activeDate={activeDate}
            handleSelectedDate={callFunctionConditionallyWithWarningCurry(
              handleDateSelect,
              hasActiveEdits
            )}
            handlePreviousDate={callFunctionConditionallyWithWarningCurry(
              contextualButtonProps.handleClick,
              hasActiveEdits,
            )}
            buttonTitle={contextualButtonProps.text}
          />
        </div>
        {showAttributesMenu && (
          <div style={{ display: 'inline-block', marginTop: '5px' }}>
            <AttributesSelector
              selectedOptionalCols={selectedOptionalColNames}
              columns={optionalColumnsWithShift}
              applyColumnsSelection={applyColumnsSelection}
            />
          </div>
        )}
        <div className={styles.lineSelect}>
          <div className={styles.selectorSmall}>
            <span className={styles.captionSmall}>Chassis Line</span>
          </div>
          <div className={styles.selectorBt}>
            <LineDropdownSelector hasActiveEdits={hasActiveEdits} />
          </div>
        </div>
      </div>
      {restrictNavigationDuringEditing && (
        <Prompt
          when={hasActiveEdits}
          message={() => DISPLAY_MESSAGES.NAVIGATION_WARNING}
        />
      )}
    </div>
  );
};
AggregateToolbar.propTypes = {
  restrictNavigationDuringEditing: PropTypes.bool.isRequired,
  hasActiveEdits: PropTypes.bool.isRequired,
  activeDate: PropTypes.objectOf(moment),
  dates: PropTypes.arrayOf(PropTypes.objectOf(moment)),
  handleDateSelect: PropTypes.func.isRequired,
  selectedOptionalColNames: PropTypes.arrayOf(PropTypes.string),
  applyColumnsSelection: PropTypes.func.isRequired,
  isAggregateFilterEnabled: PropTypes.bool.isRequired,
  handleSwitch: PropTypes.func.isRequired,
  lastRefreshedDate: PropTypes.objectOf(moment),
  contextualButtonProps: PropTypes.shape({
    label: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    className: PropTypes.string,
    handleClick: PropTypes.func.isRequired,
  }),
  showAttributesMenu: PropTypes.bool,
};

export default AggregateToolbar;
